const POP_POS_OFFSET = 10; // ポップアップの位置調整用変数
const SCROLL_POS_OFFSET = 120; // スクロール時の位置調整用変数
const SCROLL_POS_OFFSET_MINUS = 120; // スクロール時の位置調整用変数

export function popupView() {
  const popCloseAll = document.querySelectorAll('.js-popClose');
  const popTriggerAll = document.querySelectorAll('.js-popTrigger');
  const thisCardUiTextAll = document.querySelectorAll('.js-popUiText'); // カード内テキスト要素を取得
  const IS_ACTIVE = 'is-active';
  const IS_VIEW = 'is-view';

  popTriggerAll.forEach((target) => {
    target.addEventListener('click', () => {
      const popWrapEle = target.parentNode.parentNode.querySelector('.js-popWrap');
      const popContAll = popWrapEle.querySelectorAll('.js-popCont');
      let popToScroll;

      // ポップアップが展開されている時
      if (target.classList.contains(IS_ACTIVE)) {
        const activePopContEle = document.querySelector('.js-popCont.is-view');

        for (let i = 0; i < popTriggerAll.length; i++) {
          popTriggerAll[i].classList.remove(IS_ACTIVE);
        }

        for (let i = 0; i < thisCardUiTextAll.length; i++) {
          const dataEn = thisCardUiTextAll[i].dataset.en;

          if (dataEn == 'true') {
            thisCardUiTextAll[i].textContent = 'Click here for details about the initiative.';
          } else {
            thisCardUiTextAll[i].textContent = '取り組み内容はこちら';
          }
        }

        // 選択したカードからACTIVEクラスを削除
        target.classList.remove(IS_ACTIVE);

        // ポップアップから表示クラスを削除
        popWrapEle.classList.remove(IS_VIEW);
        activePopContEle.classList.remove(IS_VIEW);
      } else {
        const thisUiText = target.querySelector('.js-popUiText');
        let thisUiTextLang = '';

        if (thisUiText.getAttribute('data-en')) {
          thisUiTextLang = thisUiText.dataset.en;
        }

        for (let i = 0; i < thisCardUiTextAll.length; i++) {
          const dataEn = thisCardUiTextAll[i].dataset.en;

          if (dataEn == 'true') {
            thisCardUiTextAll[i].textContent = 'Click here for details about the initiative.';
          } else {
            thisCardUiTextAll[i].textContent = '取り組み内容はこちら';
          }
        }

        if (thisUiTextLang != '') {
          thisUiText.textContent = 'Close';
        } else {
          thisUiText.textContent = '閉じる';
        }

        // 選択したカードのデータタイプ取得
        const thisCardDataType = target.dataset.type;

        // 選択したカードの親要素の取得
        const thisTriggerParent = target.closest('.js-popParent');

        // 選択したカード内で展開するポップアップ要素の取得
        const thisPopWrap = thisTriggerParent.querySelector('.js-popWrap');

        // 選択したカードの親要素のviewportに対する相対位置の取得
        const triggerRect = target.getBoundingClientRect();

        // 選択したカードのviewportに対する相対位置の取得
        const parentRect = thisTriggerParent.getBoundingClientRect();

        // popTriggerAllからACTIVEクラスを削除
        for (let i = 0; i < popTriggerAll.length; i++) {
          popTriggerAll[i].classList.remove(IS_ACTIVE);
        }

        // 選択したカードの高さを取得
        const thisTargetHeight = target.clientHeight;
        // 選択したカードの親要素と、選択したカードまでの距離を計算
        const relativeTop = triggerRect.top - parentRect.top + thisTargetHeight + POP_POS_OFFSET;

        // 表示するポップアップの位置を設定
        thisPopWrap.style.top = relativeTop + 'px';

        // 表示したポップアップまでの位置を計算
        if (target.querySelector('img')) {
          popToScroll = triggerRect.top + window.pageYOffset + SCROLL_POS_OFFSET;
        } else {
          popToScroll = triggerRect.top + window.pageYOffset - SCROLL_POS_OFFSET_MINUS;
        }

        // 表示したポップアップの位置まで画面をスクロール
        window.scrollTo({
          top: popToScroll, //目的の位置のY座標を指定
          behavior: 'smooth', //スクロールの動きを指定
        });

        // 選択したカードにACTIVEクラスを付与
        target.classList.add(IS_ACTIVE);

        // ポップアップに表示クラスを付与
        popWrapEle.classList.add(IS_VIEW);

        // 選択したカードと同じデータタイプのポップアップ内のコンテンツを表示
        for (let i = 0; i < popContAll.length; i++) {
          const thisPopContDataType = popContAll[i].dataset.type;

          if (thisCardDataType == thisPopContDataType) {
            popContAll[i].classList.add(IS_VIEW);
          } else {
            popContAll[i].classList.remove(IS_VIEW);
          }
        }
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.js-popTrigger') && !e.target.closest('.js-popWrap')) {
      closePop();
    }
  });

  popCloseAll.forEach((target) => {
    target.addEventListener('click', () => {
      closePop();
    });
  });

  function closePop() {
    if (document.querySelector('.js-popWrap.is-view')) {
      const activePopWrapEle = document.querySelector('.js-popWrap.is-view');
      const activePopContEle = document.querySelector('.js-popCont.is-view');

      for (let i = 0; i < popTriggerAll.length; i++) {
        popTriggerAll[i].classList.remove(IS_ACTIVE);
      }

      activePopContEle.classList.remove(IS_VIEW);
      activePopWrapEle.classList.remove(IS_VIEW);

      for (let i = 0; i < thisCardUiTextAll.length; i++) {
        const dataEn = thisCardUiTextAll[i].dataset.en;

        if (dataEn == 'true') {
          thisCardUiTextAll[i].textContent = 'Click here for details about the initiative.';
        } else {
          thisCardUiTextAll[i].textContent = '取り組み内容はこちら';
        }
      }
    }
  }
}

export function resizeWindowPos() {
  const selectedCardEle = document.querySelector('.js-popTrigger.is-active');
  const activePopWrapEle = document.querySelector('.js-popWrap.is-view');

  const thisTriggerParent = selectedCardEle.closest('.js-popParent');
  const selectedCardRect = selectedCardEle.getBoundingClientRect();
  const parentRect = thisTriggerParent.getBoundingClientRect();

  // 選択したカードの高さを取得
  const thisTargetHeight = selectedCardEle.clientHeight;
  // 選択したカードの親要素と、選択したカードまでの距離を計算
  const relativeTop = selectedCardRect.top - parentRect.top + thisTargetHeight + POP_POS_OFFSET;

  // 表示するポップアップの位置を設定
  activePopWrapEle.style.top = relativeTop + 'px';
}
